import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    CircularProgress,
    InputAdornment
} from '@mui/material';

const RadiologistFormDialog = ({ open, onClose, selectedRadiologist, formik, loading }) => {
    console.log('Selected Radiologist:', selectedRadiologist);
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {selectedRadiologist ? t('radiologists.editTitle') : t('radiologists.addTitle') || 'Add Radiologist'}
            </DialogTitle>
            <DialogContent>
                <Box component="form" onSubmit={formik.handleSubmit} sx={{ mt: 2 }}>
                    <TextField
                        fullWidth
                        label={t('radiologists.name') || 'Name'}
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                        required
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        fullWidth
                        label={t('radiologists.username') || 'Username'}
                        name="username"
                        value={formik.values.username}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.username && Boolean(formik.errors.username)}
                        helperText={formik.touched.username && formik.errors.username}
                        required
                        sx={{ mb: 2 }}
                    />

                    <FormControl fullWidth error={formik.touched.gender && Boolean(formik.errors.gender)} sx={{ mb: 2 }}>
                        <InputLabel>{t('radiologists.gender') || 'Gender'}</InputLabel>
                        <Select
                            name="gender"
                            value={formik.values.gender}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label={t('radiologists.gender') || 'Gender'}
                        >
                            <MenuItem value="male">{t('genders.male')}</MenuItem>
                            <MenuItem value="female">{t('genders.female')}</MenuItem>
                            <MenuItem value="other">{t('genders.other')}</MenuItem>
                        </Select>
                        {formik.touched.gender && formik.errors.gender && (
                            <Typography color="error" variant="caption">
                                {formik.errors.gender}
                            </Typography>
                        )}
                    </FormControl>

                    <TextField
                        fullWidth
                        label={t('radiologists.age') || 'Age'}
                        name="age"
                        type="number"
                        value={formik.values.age}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.age && Boolean(formik.errors.age)}
                        helperText={formik.touched.age && formik.errors.age}
                        required
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        fullWidth
                        label={t('radiologists.phoneNumber') || 'Phone Number'}
                        name="phoneNumber"
                        value={formik.values.phoneNumber}
                        onChange={e => {
                            const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                            formik.setFieldValue('phoneNumber', val);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                        helperText={formik.touched.phoneNumber && formik.errors.phoneNumber || t('radiologists.phoneFormatHelper')}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">+20</InputAdornment>,
                            inputProps: { maxLength: 10, pattern: '[0-9]{10}' }
                        }}
                        required
                        sx={{ mb: 2 }}
                    />

                    {/* Only show password fields when adding */}
                    {!selectedRadiologist && (
                        <>
                            <TextField
                                fullWidth
                                label={t('radiologists.password') || 'Password'}
                                name="password"
                                type="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                required
                                sx={{ mb: 2 }}
                            />
                            <TextField
                                fullWidth
                                label={t('radiologists.confirmPassword') || 'Confirm Password'}
                                name="confirmPassword"
                                type="password"
                                value={formik.values.confirmPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                                required
                                sx={{ mb: 2 }}
                            />
                        </>
                    )}

                    <DialogActions>
                        <Button onClick={onClose}>{t('common.cancel')}</Button>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} /> : (selectedRadiologist ? t('common.update') : t('common.add'))}
                        </Button>
                    </DialogActions>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default RadiologistFormDialog;